import { TableRefresh } from "../../../../_ovlclient/src/library/table/tableapi"

export const RefreshResultingPermission = (cntctCode: number) => {
  TableRefresh("SYSUserAdministration_ResultingPermission", {
    serverFilter: {
      RoleCode: "@@SYSGetResultingRole",
      Permission: cntctCode,
    },
    resetStrategy: { ClearData: true },
  })
}
